import React, { useEffect, useRef, useState } from "react";
// Components
import { Filters, Header, Pagination, Table } from "Components/ViewImportsData";

// Hooks
import { useImportsFileDataTable } from "hooks/useTable";
// Store Utils
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { filtersInitialState } from "store/filters/initialState";
import { TailSpin } from "react-loader-spinner";
import NoRecordFound from "view/components/NoRecordFound";
import { useParams } from "react-router-dom";
import { fetchImportsFileDataAction } from "store/importsViewData/reducer.actions";
import { fetchImportsFile } from "store/importsViewData/initialState";
import { importsViewDataResetFilter } from "store/filters/reducer.actions";
import useCustomBranding from "hooks/useCustomBranding";

export const ViewImportsData = () => {
  const [showInput, setShowInput] = useState(false);
  // Import ID
  const { importId } = useParams();

  const inputRef = useRef<HTMLDivElement>(null);
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const { data, stateIs } = useSelector<RootState, fetchImportsFile>(
    (state) => state?.importsFileData
  );
  const { importsViewDataFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state.Filters
  );
  const { primaryColor} = useCustomBranding();

  const {
    flexRender,
    columnVisibility,
    columnOrder,
    columnsConfig,
    table,
    setColumnsConfig,
    setColumnOrder,
    setColumnVisibility,
    setSorting,
    sorting,
  } = useImportsFileDataTable(data.importedFileData);

  useEffect(() => {
    if (importId) {
      dispatch(fetchImportsFileDataAction(Number(importId)));
    }
  }, [importsViewDataFilter]);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target as Node) &&
        importsViewDataFilter.searchString === ""
      ) {
        setShowInput(false);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [importsViewDataFilter.searchString]);

  useEffect(() => {
    return () => {
      dispatch(importsViewDataResetFilter());
    };
  }, []);

  return (
    <div className="flex flex-col justify-start items-start w-full pt-4 pb-20">
      <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 w-full gap-3">
        <Header />
        <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 mb-2 w-full">
          <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0">
            <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0">
              <Filters
                columnOrder={columnOrder}
                setColumnOrder={setColumnOrder}
                columns={columnsConfig}
                columnVisibility={columnVisibility}
                setColumnVisibility={setColumnVisibility}
                setColumnsConfig={setColumnsConfig}
              />
            </div>
          </div>
        </div>

        <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 w-full dark:bg-secondaryLight bg-bgWhite">
          {stateIs == "Idle" && data?.importedFileData?.length === 0 ? (
            <NoRecordFound />
          ) : stateIs === "Pending" ? (
            <div className="loader min-h-[45vh] justify-center items-center flex w-full">
              <TailSpin
                height="50"
                width="50"
                color={primaryColor}
                ariaLabel="tail-spin-loading"
                radius="2"
                wrapperStyle={{}}
                wrapperClass="tailspin-loader"
                visible={true}
              />
            </div>
          ) : (
            <Table
              flexRender={flexRender}
              table={table}
              columnOrder={columnOrder}
              columns={columnsConfig}
              columnVisibility={columnVisibility}
              setSorting={setSorting}
              sorting={sorting}
            />
          )}
          <Pagination />
        </div>
      </div>
    </div>
  );
};
export default ViewImportsData;
